var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationagentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5317 14.2385C40.5317 19.246 36.4725 23.3052 31.4652 23.3052C26.4578 23.3052 22.3984 19.246 22.3984 14.2385C22.3984 9.23115 26.4578 5.17188 31.4652 5.17188C36.4725 5.17188 40.5317 9.23115 40.5317 14.2385Z",
    stroke: "#3162AC",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4648 21.7031V32.3698",
    stroke: "#3162AC",
    strokeWidth: 3.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4648 43.5691V32.9023H47.4648V43.5691",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4651 60.6372C20.4725 60.6372 24.5317 56.578 24.5317 51.5706C24.5317 46.5631 20.4725 42.5039 15.4651 42.5039C10.4577 42.5039 6.39844 46.5631 6.39844 51.5706C6.39844 56.578 10.4577 60.6372 15.4651 60.6372Z",
    stroke: "#3162AC",
    strokeWidth: 3.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5317 51.5706C56.5317 56.578 52.4725 60.6372 47.4652 60.6372C42.4578 60.6372 38.3984 56.578 38.3984 51.5706C38.3984 46.5633 42.4578 42.5039 47.4652 42.5039C52.4725 42.5039 56.5317 46.5633 56.5317 51.5706Z",
    stroke: "#3162AC",
    strokeWidth: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationagentIcon);
export default __webpack_public_path__ + "static/media/ConfirmationagentIcon.0490e8aebe15c4093adee59814542088.svg";
export { ForwardRef as ReactComponent };